import { useAuth } from 'src/hooks';
import { AuthLayout } from './auth/AuthLayout';
import { NonAuthLayout } from './nonAuth/NonAuthLayout';

export const ErrorLayout = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <NonAuthLayout />;
  }

  return <AuthLayout />;
};
